import moment from "moment";
import { DataTableV2DateTypes } from "../preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";

export const dataTableV2DatesFilter = (format = "YYYY-MM-DD") => {
  const today = moment().format(format);
  const tomorrow = moment().add(1, "days").format(format);
  const yesterday = moment().subtract(1, "days").format(format);

  const currentDate = moment();

  const lastweek = moment().subtract(1, "weeks").format(format);
  const lastMonth = moment().subtract(1, "month").format(format);
  const last30Days = moment().subtract(30, "days").format(format);
  const last90Days = moment().subtract(90, "days").format(format);
  const last7Days = moment().subtract(6, "days").format(format);
  const last3Months = moment().subtract(3, "months").format(format);
  const last6Months = moment().subtract(6, "months").format(format);

  const startDateOfMonth = currentDate.startOf("month").format(format);
  const startOfYear = moment().startOf("year").format(format);
  const thisWeekStartDate = moment().clone().startOf("isoWeek").format(format);
  const thisWeekEndDate = moment().clone().endOf("isoWeek").format(format);
  const endDateOfMonth = currentDate.endOf("month").format(format);

  /* ---------- UPCOMING (EXCLUDING CURRENT) ---------- */

  // 🔹 Upcoming Week (next Monday → next Sunday)

  const upcomingWeekStart = moment()
    .clone()
    .add(1, "weeks")
    .startOf("isoWeek")
    .format(format);

  const upcomingWeekEnd = moment()
    .clone()
    .add(1, "weeks")
    .endOf("isoWeek")
    .format(format);

  // 🔹 Upcoming Month (skip current month)
  const upcomingMonthStart = moment()
    .clone()
    .add(1, "month")
    .startOf("month")
    .format(format);

  const upcomingMonthEnd = moment()
    .clone()
    .add(1, "month")
    .endOf("month")
    .format(format);

  // 🔹 Upcoming 3 Months (full months)
  const upcoming3MonthsStart = moment()
    .clone()
    .add(1, "month")
    .startOf("month")
    .format(format);

  const upcoming3MonthsEnd = moment()
    .clone()
    .add(3, "months")
    .endOf("month")
    .format(format);

  const upcoming30DaysEnd = moment().clone().add(30, "days").format(format);

  return {
    today,
    tomorrow,
    yesterday,

    lastweek,
    thisWeekStartDate,
    thisWeekEndDate,
    lastMonth,
    last30Days,
    last90Days,
    last7Days,
    last6Months,
    startDateOfMonth,
    last3Months,
    startOfYear,
    endDateOfMonth,

    upcomingWeekStart,
    upcomingWeekEnd,
    upcomingMonthStart,
    upcomingMonthEnd,
    upcoming3MonthsStart,
    upcoming3MonthsEnd,
    upcoming30DaysEnd,
  };
};

export const getDataTablev2InitialDate = (
  type: DataTableV2DateTypes,
  format?: string,
) => {
  const {
    today,
    tomorrow,
    lastweek,
    startDateOfMonth,
    yesterday,
    last30Days,
    last90Days,
    last6Months,
    last7Days,
    thisWeekStartDate,
    thisWeekEndDate,
    last3Months,
    startOfYear,
    lastMonth,
    endDateOfMonth,
    upcomingWeekStart,
    upcomingWeekEnd,
    upcomingMonthStart,
    upcomingMonthEnd,
    upcoming3MonthsStart,
    upcoming3MonthsEnd,
    upcoming30DaysEnd,
  } = dataTableV2DatesFilter(format);
  if (type === "yesterday") {
    return { fromDate: yesterday, toDate: yesterday };
  } else if (type === "today") {
    return { fromDate: today, toDate: today };
  } else if (type === "lastWeek") {
    return { fromDate: lastweek, toDate: today };
  } else if (type === "thisMonth") {
    return { fromDate: startDateOfMonth, toDate: today };
  } else if (type === "last30Days") {
    return { fromDate: last30Days, toDate: today };
  } else if (type === "last90Days") {
    return { fromDate: last90Days, toDate: today };
  } else if (type === "last6Months") {
    return { fromDate: last6Months, toDate: today };
  } else if (type === "last7Days") {
    return { fromDate: last7Days, toDate: today };
  } else if (type === "thisWeek") {
    return { fromDate: thisWeekStartDate, toDate: thisWeekEndDate };
  } else if (type === "lastMonth") {
    return { fromDate: lastMonth, toDate: today };
  } else if (type === "last3Months") {
    return { fromDate: last3Months, toDate: today };
  } else if (type === "thisYear") {
    return { fromDate: startOfYear, toDate: today };
  } else if (type === "allTimes") {
    return { fromDate: "", toDate: "" };
  } else if (type === "tomorrow") {
    return { fromDate: tomorrow, toDate: tomorrow };

    /* ---------- UPDATED UPCOMING LOGIC ---------- */
  } else if (type === "upcomingWeek") {
    return {
      fromDate: upcomingWeekStart,
      toDate: upcomingWeekEnd,
    };
  } else if (type === "upcomingMonth") {
    return {
      fromDate: upcomingMonthStart,
      toDate: upcomingMonthEnd,
    };
  } else if (type === "upcoming3Months") {
    return {
      fromDate: upcoming3MonthsStart,
      toDate: upcoming3MonthsEnd,
    };
  } else if (type === "upcomingThisWeek") {
    return {
      fromDate: today,
      toDate: thisWeekEndDate,
    };
  } else if (type === "upcomingThisMonth") {
    return { fromDate: today, toDate: endDateOfMonth };
  } else if (type === "upcoming30Days") {
    return { fromDate: today, toDate: upcoming30DaysEnd };
  }
  // Default fallback to last30Days
  return { fromDate: last30Days, toDate: today };
};
